<template>
  <div class="up-mask flex-box">
    <div class="desc">
      <h2>
        更新通知
      </h2>
      <br />
      <p style="text-align: left;">
        抱歉，由于插件版本过低，功能已经无法正常使用。最新版本已经进化到V2.0.1啦！<br /><br />
        1. 功能升级自动化<br />
        2. 底层优化数据更实时稳定<br />
        3. 增加了伪原创功能<br />
        4. 增加了违规词功能<br />
        5. 增加了更丰富的导出数据<br />
        等等...<br /><br />

        还有更多为站长打造的免费智能功能陆续加入，立即升级吧！<br /><br />
      </p>
      <a
        href="https://tool.5118.com?operation=update#type-tab"
        target="_blank"
        class="link"
        >【下载更新】</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'Main',
};
</script>

<style scoped lang="less" type="text/less">
@import '../../../assets/style/color.less';
@import '../../../assets/style/config.less';
@import '../../../assets/style/mixin.less';

.up-mask {
  background-color: fade(black, 70);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 20%;
  height: 100vh;
  z-index: 2000;
  text-align: center;
  padding: 0 12px;
  .desc {
    color: white;
    .link {
      margin-top: 30px;
      display: inline-block;
      padding: 0 15px;
      color: #ffffff;
      font-weight: 400;
      font-size: 14px;
      line-height: 35px;
      border-radius: 2px;
      text-decoration: none;
      border: 0;
      outline: 0;
      background: #166df1 none;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/Up/index.vue